//=====================================================================
// Shared JS files
//=====================================================================
//import { setCurrentNavItem } from './setCurrentNavItem.js';
import htmx from './htmx-json-enc.esm.js';


//Bootstrap
//import * as Popper from '@popperjs/core';
//import { Modal } from 'bootstrap';

//Source Tracking. Now works server side rather than js
//import { sourceTracking } from './sourceTracking/sourceTracking.js';

//=====================================================================
// JQuery (currently used in slick.js & validation)
//=====================================================================
import $ from 'jquery';
window.jQuery = window.$ = $; 

import 'jquery-validation';
import 'jquery-validation-unobtrusive';

//=====================================================================
// Other shared JS
//=====================================================================
import 'slick-carousel'; 
import { fancyboxJS } from './fancyboxJS/index.js';     

//=====================================================================
// Custom JS files 
//=====================================================================
import { headerJS } from './headerJS/index.js';
import { cookieMessageJS } from './cookieMessageJS/index.js'; 
import { setCurrentNavItemJS } from './setCurrentActiveLinkJS';
import { stickySectionsJS } from './stickySectionsJS/index.js'; 
import { resizeAnimationStopperJS } from './resizeAnimationStopperJS/index.js';  
import { countdownJS } from './countdownJS/index.js';   

import { slickSliderJS } from './slickSliderJS/index.js';  
window.slickSliderJS = slickSliderJS; 

import { modalJS, closeModal } from './modalJS/index.js'; 
window.modalJS = modalJS;
window.closeModal = closeModal;
import { tabsJS } from './tabsJS/index.js';   
import { accordiansJS } from './accordianJS/index.js';  
import { initializeTooltips } from './tooltipJS/index.js';  
initializeTooltips();

// Free Type (algolia)
import './algoliaJS/algolia.js';

// Tour Search
import './tourCard/depDateSelectListChange.js';      

//=====================================================================
// Tour Search Filtering
//=====================================================================
import { tourSearch } from './tourSearch/tourSearch.js';

import GADataLayerHelper from './googleAnalytics/gaDataLayerHelper.js';
